export const calendarKeys = {
	all: ['crm', 'calendar'],
	connections: () => ['crm', 'calendar', 'connections'],
};
